import { ImageFallbackIcon } from "../../Assets/assets";
import AudioPlayer from "../../Components/AudioPlayer/AudioPlayer";
import { isValidArray } from "../../Services/validators";

// const getTurnaroundTime = (timestamp) => {
//   const hours = timestamp / (1000 * 60 * 60);

//   if (hours % 24 === 0) {
//     return `${hours / 24} Days`;
//   } else {
//     return `${hours} Hour${hours !== 1 ? "s" : ""}`;
//   }
// };

export function getComplaintDetailsData(compliantData, setShow) {
  return [
    { title: "COMPLAINT", value: compliantData?.category },
    { title: "COMPLAINT ID", value: compliantData?.documentId },
    { title: "STATUS", value: compliantData?.status?.currentStatus },
    {
      title: "COMPLAINT REGISTERED BY",
      value: `${compliantData?.issuedBy?.userDetails?.name || "N/A"}, ${
        compliantData?.issuedBy?.userDetails?.phoneNumber || "N/A"
      }`
    },
    {
      title: "LOCATION",
      value: `${
        compliantData?.location?.PCTNo?.toString().padStart(2, "0") || "N/A"
      } - ${compliantData?.location?.address}`
    },
    ...(compliantData?.penalty?.amount
      ? [{ title: "PENALTY", value: compliantData.penalty.amount }]
      : []),
    // ...(compliantData?.turnaround
    //   ? [
    //       {
    //         title: "TURNAROUND TIME",
    //         value: (
    //           <div className=" inherit-parent-width display-flex flex-align-items-center flex-justify-content-space-between">
    //             <div>
    //             {dateAndTimeConverter(compliantData.turnaround, "Time")} {", "} {dateAndTimeConverter(compliantData.turnaround, "secondDate")}
    //             </div>
    //             <div className=" font-size-smaller">
    //               {convertTimestampToTimer(
    //                 getRemainingTime(
    //                   compliantData.turnaround,
    //                   compliantData.closure?.resolvedAt
    //                 )
    //               )}

    //             </div>
    //           </div>
    //         )
    //       }
    //     ]
    //   : []),
    ...(isValidArray(compliantData?.assets)
      ? [
          {
            title: "IMAGE",
            value: (
              <>
                {isValidArray(compliantData?.fileSrc?.images) ? (
                  <ImageViewer
                    images={compliantData.fileSrc.images}
                    setShow={setShow}
                  />
                ) : (
                  <div
                    className="height-fit-content width-fit-content border-radius-default margin-right-default margin-bottom-default"
                    data-cy="proof-image-fallBack"
                  >
                    <div className="height-width-56px border-radius-default inherit-parent-height inherit-parent-width background-color-grey display-flex flex-justify-content-center flex-align-items-center">
                      <ImageFallbackIcon />
                    </div>
                  </div>
                )}
              </>
            )
          }
        ]
      : []),
    ...(compliantData?.fileSrc?.audio
      ? [
          {
            title: "AUDIO",
            value: (
              <AudioPlayer
                className=" max-width-500px"
                src={
                  compliantData?.fileSrc?.audio
                    ? compliantData.fileSrc.audio
                    : " "
                }
              />
            )
          }
        ]
      : []),
    {
      title: "PREVIOUSLY LINKED CONTACTS",
      value: (
        <div className="">
          {isValidArray(compliantData?.issuedBy?.linkedWith) ? (
            <div className="display-flex flex-justify-content-space-between">
              <div className="display-flex">
                <div
                  style={{
                    maxWidth:
                      compliantData?.issuedBy?.linkedWith?.length > 1
                        ? "200px"
                        : "100%"
                  }}
                  className="text-overflow-ellipsis"
                >{`${
                  compliantData?.issuedBy?.linkedWith?.[0]?.userDetails
                    ?.phoneNumber
                }
                -
                ${
                  compliantData?.issuedBy?.linkedWith?.[0]?.userDetails?.name ||
                  "N/A"
                }`}</div>

                {compliantData?.issuedBy?.linkedWith?.length > 1 && (
                  <div>{` ${`, +${
                    compliantData?.issuedBy?.linkedWith.length - 1
                  } more`}`}</div>
                )}
              </div>
              {compliantData?.issuedBy?.linkedWith.length > 1 && (
                <div
                  onClick={() => {
                    setShow((prev) => ({
                      ...prev,
                      linkedPhoneNumbers: true
                    }));
                  }}
                  className="font-color-primary"
                  data-cy="show-all-linked-phone-numbers"
                >
                  Show All
                </div>
              )}
            </div>
          ) : (
            <div>N/A</div>
          )}
        </div>
      )
    },
    {
      title: "UPDATES",
      value: (
        <div className="">
          {isValidArray(compliantData?.latestUpdate) ? (
            <div className="display-flex flex-justify-content-space-between">
              <div className="display-flex">
                <div
                  style={{
                    maxWidth:
                      compliantData?.latestUpdate.length > 1 ? "200px" : "100%"
                  }}
                  className="text-overflow-ellipsis"
                >
                  {compliantData?.latestUpdate?.[0]?.description || "N/A"}
                </div>
                {compliantData?.latestUpdate.length > 1 && (
                  <div>{`, +${
                    compliantData?.latestUpdate.length - 1
                  } more`}</div>
                )}
              </div>
              <div
                onClick={() => {
                  setShow((prev) => ({
                    ...prev,
                    updates: true
                  }));
                }}
                className="font-color-primary"
                data-cy="show-all-updates"
              >
                Show All
              </div>
            </div>
          ) : (
            <div>N/A</div>
          )}
        </div>
      )
    }
  ];
}

export const ImageViewer = (props) => {
  return (
    <div className="inherit-parent-width display-flex flex-wrap">
      {props.images.map((url, index) => (
        <div
          key={index}
          className={`height-width-56px margin-bottom-default ${
            props.images.length === index + 1 ? " " : "margin-right-default"
          } `}
          onClick={() => {
            props.setShow((prev) => ({
              ...prev,
              image: url
            }));
          }}
        >
          <img
            className="border-radius-default inherit-parent-height inherit-parent-width"
            data-cy={`PROOF-IMAGE-${index + 1}`}
            src={url}
            alt="images"
          />
        </div>
      ))}
    </div>
  );
};
